{
    "Accessibility Menu": "অভিগম্যতা মেনু",
    "Reset settings": "নির্ধারণ পুনরায় সেট করুন",
    "Close": "বন্ধ করুন",
    "Content Adjustments": "কন্টেন্ট সংশোধন",
    "Adjust Font Size": "ফন্ট সাইজ সংশোধন",
    "Highlight Title": "শিরোনাম উজ্জ্বল করুন",
    "Highlight Links": "লিঙ্কগুলি উজ্জ্বল করুন",
    "Readable Font": "পঠনীয় ফন্ট",
    "Color Adjustments": "রঙ সংশোধন",
    "Dark Contrast": "অন্ধকারী প্রতিবিম্ব",
    "Light Contrast": "আলোকিত প্রতিবিম্ব",
    "High Contrast": "উচ্চ প্রতিবিম্ব",
    "High Saturation": "উচ্চ সত্রাজন",
    "Low Saturation": "নিম্ন সত্রাজন",
    "Monochrome": "একরঙ",
    "Protanopia": "প্রোটানোপিয়া",
    "Deuteranopia": "ডিউটেরানোপিয়া",
    "Tritanopia": "ট্রাইটানোপিয়া",
    "Visual & Navigation Aids": "দৃশ্য ও নেভিগেশন সহায়িকা",
    "Additional Tools": "অতিরিক্ত সরঞ্জাম",
    "Reading Guide": "পড়ার গাইড",
    "Stop Animations": "অ্যানিমেশন বন্ধ করুন",
    "Big Cursor": "বড় কার্সর",
    "Screen Reader": "স্ক্রিন রিডার",
    "Hide Images": "ছবি লুকান",
    "Image Tooltips": "ছবির টুলটিপ",
    "Page Structure": "পৃষ্ঠা কাঠামো",
    "Super Focus": "সুপার ফোকাস",
    "Magnifier": "বিবর্ধক",
    "Increase Font Size": "ফন্ট সাইজ বাড়ান",
    "Decrease Font Size": "ফন্ট সাইজ কমান",
    "Letter Spacing": "অক্ষর বিরাটি",
    "Line Height": "লাইন উচ্চতা",
    "Font Weight": "ফন্ট ওজন",
    "Dyslexia Font": "ডাইসলেক্সিয়া ফন্ট",
    "Language": "ভাষা",
    "Open Accessibility Menu": "অভিগম্যতা মেনু খোলুন",
    "Accessibility Profiles": "অভিগম্যতা প্রোফাইল",
    "Seizure Safe Profile": "খিঁচুনি-নিরাপদ প্রোফাইল",
    "Stops animations and reduces color saturation.": "অ্যানিমেশন বন্ধ করে এবং রঙের তীব্রতা কমায়।",
    "Blind Profile": "দৃষ্টিহীনদের প্রোফাইল",
    "Activates the screen reader for auditory navigation.": "শ্রবণ নেভিগেশনের জন্য স্ক্রিন রিডার সক্রিয় করে।",
    "Visually Impaired Profile": "দৃষ্টি প্রতিবন্ধী প্রোফাইল",
    "Enhances contrast and readability for low vision.": "কম দৃষ্টিশক্তির জন্য কন্ট্রাস্ট ও পাঠযোগ্যতা বাড়ায়।",
    "ADHD Friendly Profile": "ADHD-বান্ধব প্রোফাইল",
    "Reduces distractions for better focus.": "ভালো মনোযোগের জন্য বিক্ষেপ কমায়।",
    "Cognitive & Learning Profile": "জ্ঞানীয় ও শিক্ষামূলক প্রোফাইল",
    "Helpful tools for reading and comprehension.": "পড়া ও বোঝার জন্য সহায়ক সরঞ্জাম।",
    "Motor Impaired Profile": "মোটর প্রতিবন্ধী প্রোফাইল",
    "Optimizes the site for keyboard-only navigation.": "শুধুমাত্র কীবোর্ড নেভিগেশনের জন্য সাইট অপ্টিমাইজ করে।",
    "Headings": "শিরোনাম",
    "Landmarks": "ল্যান্ডমার্ক",
    "Links": "লিঙ্ক",
    "Focus element": "উপাদানে ফোকাস করুন",
    "Visit link": "লিঙ্ক পরিদর্শন করুন"
}
